import PolicyFallbackIcon from "@Icons/PolicyFallbackIcon";

const HouseRulesDefualtIcon = ({ width = 24, height = 24, fill = "#011851" }: any) => (
  <PolicyFallbackIcon width={width} height={height} fill={fill} />
);

export default HouseRulesDefualtIcon;
